/*
  DM — Category landing (sections/dm-category-main.liquid).
  - Selector: model range → exact model → part type, from the menu JSON in the section.
    Once the model is picked, the part type whose name contains the page's keyword
    (data-keyword) is chosen, and its collection loads at once.
  - Loading: sections/dm-category-grid.liquid through Section Rendering, 24 cards a page,
    sorted by the Sort menu (price high → low first, like the catalog). Pages are cached.
  - Memory: the choice is written to ?fitment=/collections/… (the old selector's
    parameter, so links people shared keep working) and the car to localStorage
    (dm:fitment-car), so the next category page opens on the same car. With nothing
    stored, the car last viewed in the header (dm:cars) is used when the menu has it.
  - "Clear" brings back the parts rendered with the page.
*/
(function () {
  'use strict';

  var CAR_KEY = 'dm:fitment-car';
  var FIXES = [[/Exhasut/g, 'Exhaust'], [/Porschce/g, 'Porsche'], [/\s+/g, ' ']];

  function clean(s) {
    s = String(s || '');
    FIXES.forEach(function (f) { s = s.replace(f[0], f[1]); });
    return s.trim();
  }
  function key(s) { return clean(s).toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function read(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function write(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function option(value, text) { var o = document.createElement('option'); o.value = value; o.textContent = text; return o; }

  function init(root) {
    if (root.__dmcat) return;
    root.__dmcat = true;

    var menu = [];
    try { menu = JSON.parse(root.querySelector('[data-dmcat-menu]').textContent) || []; } catch (e) { menu = []; }

    var q = function (sel) { return root.querySelector(sel); };
    var range = q('[data-dmcat-range]');
    var model = q('[data-dmcat-model]');
    var part = q('[data-dmcat-part]');
    var grid = q('[data-dmcat-grid]');
    var title = q('[data-dmcat-title]');
    var count = q('[data-dmcat-count]');
    var note = q('[data-dmcat-note]');
    var more = q('[data-dmcat-more]');
    var all = q('[data-dmcat-all]');
    var sortWrap = q('[data-dmcat-sort-wrap]');
    var sort = q('[data-dmcat-sort]');
    var statusText = q('[data-dmcat-status-text]');
    var reset = q('[data-dmcat-reset]');
    var results = q('[data-dmcat-results]');

    var keyword = (root.getAttribute('data-keyword') || '').toLowerCase();
    var label = root.getAttribute('data-label') || 'parts';
    var endpoint = root.getAttribute('data-endpoint') || 'dm-category-grid';
    var defaultUrl = root.getAttribute('data-default-url') || '';
    var defaultPages = parseInt(root.getAttribute('data-default-pages'), 10) || 1;

    var initial = {
      grid: grid.innerHTML,
      title: title.textContent,
      count: count.textContent,
      moreHidden: more.hidden,
      hint: statusText ? statusText.textContent : ''
    };
    var modelPlaceholder = model ? model.options[0].textContent : '';
    var partPlaceholder = part ? part.options[0].textContent : '';

    var state = { url: '', page: 1, pages: 1, sort: sort ? sort.value : 'price-descending', fam: -1, mod: -1, defaultPage: 1 };
    var cache = new Map();
    var controller = null;

    function parts() {
      var f = menu[state.fam];
      var m = f && f.m[state.mod];
      return (m && m.p) || [];
    }
    function modelTitle() {
      var f = menu[state.fam];
      return f && f.m[state.mod] ? clean(f.m[state.mod].t) : '';
    }

    function fillModels() {
      model.innerHTML = '';
      model.appendChild(option('', modelPlaceholder));
      var f = menu[state.fam];
      (f ? f.m : []).forEach(function (m, i) { model.appendChild(option(i, clean(m.t))); });
      model.disabled = !f;
      fillParts();
    }
    function fillParts() {
      part.innerHTML = '';
      part.appendChild(option('', partPlaceholder));
      parts().forEach(function (p, i) { part.appendChild(option(i, clean(p.t))); });
      part.disabled = !parts().length;
    }
    function keywordPart() {
      if (!keyword) return -1;
      var list = parts();
      for (var i = 0; i < list.length; i++) {
        if (clean(list[i].t).toLowerCase().indexOf(keyword) !== -1) return i;
      }
      return -1;
    }

    function showNote(text, retry) {
      note.textContent = text;
      if (retry) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dmcat__retry';
        b.textContent = 'Try again';
        b.addEventListener('click', function () { load(false); });
        note.appendChild(document.createTextNode(' '));
        note.appendChild(b);
      }
      note.hidden = false;
    }

    function endpointUrl(url, page, sortBy) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', endpoint);
      if (sortBy) u.searchParams.set('sort_by', sortBy);
      if (page > 1) u.searchParams.set('page', page);
      return u.pathname + u.search;
    }
    function fetchPage(url, page, sortBy) {
      var req = endpointUrl(url, page, sortBy);
      if (cache.has(req)) return Promise.resolve(cache.get(req));
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      return fetch(req, controller ? { signal: controller.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-dmcat-page]');
          if (!el) throw new Error('No grid in response');
          var list = el.querySelector('ul');
          var data = {
            items: list ? list.innerHTML : '',
            count: parseInt(el.getAttribute('data-count'), 10) || 0,
            page: parseInt(el.getAttribute('data-page'), 10) || 1,
            pages: parseInt(el.getAttribute('data-pages'), 10) || 1
          };
          cache.set(req, data);
          return data;
        });
    }

    function setUrl(path) {
      try {
        var u = new URL(window.location.href);
        if (path) u.searchParams.set('fitment', path); else u.searchParams.delete('fitment');
        window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }

    function load(scroll) {
      var p = parts()[parseInt(part.value, 10)];
      if (!p) return;
      state.url = p.u;
      note.hidden = true;
      root.classList.add('is-loading');
      grid.setAttribute('aria-busy', 'true');
      var heading = modelTitle() + ' ' + clean(p.t);
      fetchPage(p.u, 1, state.sort).then(function (data) {
        grid.innerHTML = data.items;
        title.textContent = heading;
        count.textContent = data.count + (data.count === 1 ? ' part' : ' parts');
        state.page = data.page;
        state.pages = data.pages;
        more.hidden = data.pages <= 1;
        if (all) all.hidden = true;
        if (sortWrap) sortWrap.hidden = !data.count;
        if (!data.count) showNote('Nothing listed here yet. Choose another part type, or ask us what fits.');
        if (statusText) statusText.textContent = 'Showing parts for your ' + modelTitle() + '.';
        if (reset) reset.hidden = false;
        setUrl(p.u);
        if (scroll && results.getBoundingClientRect().top > window.innerHeight * 0.6) {
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        showNote('We couldn’t load these parts.', true);
      }).then(function () {
        root.classList.remove('is-loading');
        grid.removeAttribute('aria-busy');
      });
    }

    function loadMore() {
      var usingDefault = !state.url;
      var url = usingDefault ? defaultUrl : state.url;
      var page = (usingDefault ? state.defaultPage : state.page) + 1;
      if (!url) return;
      more.disabled = true;
      fetchPage(url, page, usingDefault ? '' : state.sort).then(function (data) {
        grid.insertAdjacentHTML('beforeend', data.items);
        if (usingDefault) {
          state.defaultPage = data.page;
          more.hidden = data.page >= defaultPages;
        } else {
          state.page = data.page;
          more.hidden = data.page >= state.pages;
        }
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        showNote('We couldn’t load more parts.', false);
      }).then(function () { more.disabled = false; });
    }

    // The parts rendered with the page (popular / whole collection), e.g. when the chosen
    // car has no part type for this category.
    function showDefault() {
      if (controller) controller.abort();
      state.url = '';
      state.page = 1;
      state.pages = 1;
      state.defaultPage = 1;
      grid.innerHTML = initial.grid;
      title.textContent = initial.title;
      count.textContent = initial.count;
      more.hidden = initial.moreHidden;
      if (all) all.hidden = false;
      if (sortWrap) sortWrap.hidden = true;
      setUrl('');
    }

    function saveCar() {
      var f = menu[state.fam];
      if (!f || !f.m[state.mod]) return;
      write(CAR_KEY, { f: clean(f.t), m: clean(f.m[state.mod].t), at: Date.now() });
    }

    function choose(fam, mod, partIndex, scroll) {
      state.fam = fam;
      range.value = fam >= 0 ? String(fam) : '';
      fillModels();
      if (mod < 0) return;
      state.mod = mod;
      model.value = String(mod);
      fillParts();
      var idx = partIndex != null && partIndex >= 0 ? partIndex : keywordPart();
      if (idx >= 0) {
        part.value = String(idx);
        load(scroll);
      } else {
        showDefault();
        showNote('No ' + label + ' listed for the ' + modelTitle() + ' yet. Choose another part type above, or ask us.');
        if (statusText) statusText.textContent = 'Choose a part type for your ' + modelTitle() + '.';
        if (reset) reset.hidden = false;
      }
    }

    function clearAll() {
      showDefault();
      state.fam = -1;
      state.mod = -1;
      range.value = '';
      fillModels();
      note.hidden = true;
      if (statusText) statusText.textContent = initial.hint;
      if (reset) reset.hidden = true;
      write(CAR_KEY, null);
    }

    if (range) {
      range.addEventListener('change', function () {
        state.fam = range.value === '' ? -1 : parseInt(range.value, 10);
        state.mod = -1;
        note.hidden = true;
        fillModels();
        var f = menu[state.fam];
        if (f && f.m.length === 1) {
          choose(state.fam, 0, null, true);
          saveCar();
        } else if (f) {
          model.focus();
        }
      });
      model.addEventListener('change', function () {
        if (model.value === '') { state.mod = -1; fillParts(); return; }
        choose(state.fam, parseInt(model.value, 10), null, true);
        saveCar();
      });
      part.addEventListener('change', function () {
        if (part.value === '') return;
        load(true);
      });
    }
    if (sort) sort.addEventListener('change', function () { state.sort = sort.value; load(false); });
    if (more) more.addEventListener('click', loadMore);
    if (reset) reset.addEventListener('click', clearAll);

    /* restore: ?fitment= first, then this visitor's car, then the header's last car */
    if (!range || !menu.length) return;
    var wanted = new URLSearchParams(window.location.search).get('fitment');
    if (wanted) {
      for (var fi = 0; fi < menu.length; fi++) {
        for (var mi = 0; mi < menu[fi].m.length; mi++) {
          var list = menu[fi].m[mi].p;
          for (var pi = 0; pi < list.length; pi++) {
            if (list[pi].u === wanted) { choose(fi, mi, pi, false); return; }
          }
        }
      }
    }
    var car = read(CAR_KEY);
    var carModel = car && car.m ? key(car.m) : '';
    if (!carModel) {
      var recent = read('dm:cars');
      if (recent && recent[0] && recent[0].t) carModel = key(recent[0].t);
    }
    if (carModel) {
      for (var f2 = 0; f2 < menu.length; f2++) {
        if (car && car.f && key(menu[f2].t) !== key(car.f)) continue;
        for (var m2 = 0; m2 < menu[f2].m.length; m2++) {
          if (key(menu[f2].m[m2].t) === carModel) { choose(f2, m2, null, false); return; }
        }
      }
    }
  }

  function boot() { document.querySelectorAll('[data-dmcat]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
